import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from "firebase/functions";
import { getAnalytics } from "firebase/analytics";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyAfWAWH_s04DFifzfrzw-t7jj8cUZynin0",
  authDomain: "romi-resume-builer.firebaseapp.com",
  projectId: "romi-resume-builer",
  storageBucket: "romi-resume-builer.firebasestorage.app",
  messagingSenderId: "614253374825",
  appId: "1:614253374825:web:9b5d88d305d424c10f21f8",
  measurementId: "G-BXD26N5CNQ"
};

const app = initializeApp(firebaseConfig);

// === Firebase App Check ===
// Enable in Firebase Console → App Check → register Web app with reCAPTCHA v3.
// Drop the resulting site key into REACT_APP_RECAPTCHA_SITE_KEY (.env.local for
// dev, hosting/CI env for prod). Without the env var App Check stays off — handy
// for local dev with the emulator.
//
// For a local dev debug token, set:
//   REACT_APP_APPCHECK_DEBUG_TOKEN = 'true'   (auto-generates and prints in console)
// or paste a token issued in Firebase Console → App Check → Debug tokens.
if (typeof window !== 'undefined' && process.env.REACT_APP_RECAPTCHA_SITE_KEY) {
  try {
    if (process.env.REACT_APP_APPCHECK_DEBUG_TOKEN) {
      // eslint-disable-next-line no-restricted-globals
      self.FIREBASE_APPCHECK_DEBUG_TOKEN =
        process.env.REACT_APP_APPCHECK_DEBUG_TOKEN === 'true'
          ? true
          : process.env.REACT_APP_APPCHECK_DEBUG_TOKEN;
    }
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(process.env.REACT_APP_RECAPTCHA_SITE_KEY),
      isTokenAutoRefreshEnabled: true
    });
  } catch (e) {
    console.warn('App Check initialization failed:', e);
  }
}

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, 'us-central1');

// Initialize Analytics (only in browser environment)
let analytics = null;
if (typeof window !== 'undefined') {
  try {
    analytics = getAnalytics(app);
  } catch (e) {
    console.warn('Analytics initialization failed:', e);
  }
}
export { analytics };
